const featureFlags = {
  PARTNER_CENTER: 'partner_center',
  MAGIC_AI_TRIAL: 'magic_ai_trial',
  APPROVALS: 'approvals',
  DESKTOP_ICON_FIELD: 'desktop_icon_field',
  TIMEZEST_INTEGRATION: 'timezest_integration',
  MAGIC_AGENT: 'magic-agent',
  COPILOT_GENERATE_TITLE: 'copilot_generate_title',
  TEAMS_GROUP_CHATS: 'teams_group_chats'
};

export default featureFlags;
